import type { OnboardingV2State } from '../store/onboardingV2/types.ts';

export const COMMERCE_ONBOARDING_CATEGORY_IDS = [16, 9, 3, 12] as const;

export function userHasCommerceOnboardingCategory(state: OnboardingV2State): boolean {
  const allowed = new Set<number>(COMMERCE_ONBOARDING_CATEGORY_IDS);
  const catalog = state.skills;
  const selected = state.userSkills;
  if (!catalog?.length || !selected?.length) return false;
  for (const us of selected) {
    const sk = catalog.find((s) => s.id === us.id);
    if (sk && allowed.has(sk.categoryId)) return true;
  }
  return false;
}

export function userSkillIdsMatchCommerceCategories(
  skillIds: number[],
  catalog: { id: number; categoryId: number }[]
): boolean {
  if (!skillIds.length || !catalog.length) return false;
  const allowed = new Set<number>(COMMERCE_ONBOARDING_CATEGORY_IDS);
  for (const sid of skillIds) {
    const sk = catalog.find((s) => s.id === sid);
    if (sk && allowed.has(sk.categoryId)) return true;
  }
  return false;
}
